import { ActionIcon, Tooltip } from '@mantine/core';
import { IconArrowAutofitWidth, IconFocusAuto, IconMapMinus, IconMapPlus } from '@tabler/icons-react';
import { Panel } from 'reactflow';
import type { SetState } from '../../../../../../react-commons/types/setState';
import { TOOLTIPS } from '../../../../resource/tooltipTexts';

export const VersionGraphPanePanel = ({
    fitView,
    setViewportToActiveNode,
    showMiniMap,
    setShowMiniMap,
    disableSetViewportToActiveNode,
}: {
    fitView: () => void;
    setViewportToActiveNode: () => void;
    showMiniMap: boolean;
    setShowMiniMap: SetState<boolean>;
    disableSetViewportToActiveNode: boolean;
}) => {
    const toggleMiniMap = () => {
        setShowMiniMap(!showMiniMap);
    };

    return (
        <Panel position="top-right">
            <Tooltip label={TOOLTIPS.FIT_VIEW} position={'left'} withArrow>
                <ActionIcon
                    onClick={() => fitView()}
                    color={'var(--mantine-color-base-button)'}
                    size={'large'}
                    style={{ paddingTop: '6px', paddingBottom: '6px' }}
                    variant={'transparent'}
                >
                    <IconArrowAutofitWidth />
                </ActionIcon>
            </Tooltip>
            <Tooltip label={TOOLTIPS.POSITION_TO_ACTIVE_NODE} position={'left'} withArrow>
                <ActionIcon
                    onClick={() => setViewportToActiveNode()}
                    color={'var(--mantine-color-base-button)'}
                    size={'small'}
                    style={{ paddingTop: '6px', paddingBottom: '6px' }}
                    disabled={disableSetViewportToActiveNode}
                    variant={'transparent'}
                >
                    <IconFocusAuto />
                </ActionIcon>
            </Tooltip>
            <Tooltip label={showMiniMap ? TOOLTIPS.HIDE_MINI_MAP : TOOLTIPS.SHOW_MINI_MAP} position={'left'} withArrow>
                <ActionIcon
                    onClick={() => toggleMiniMap()}
                    color={'var(--mantine-color-base-button)'}
                    size={'small'}
                    style={{ paddingTop: '6px', paddingBottom: '6px' }}
                    variant={'transparent'}
                >
                    {showMiniMap ?
                        <IconMapMinus />
                    :   <IconMapPlus />}
                </ActionIcon>
            </Tooltip>
        </Panel>
    );
};
